import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import GenericModal from "../Modal/GenericModal";
import YourElementsList from "./YourElementsList";
import DomainAssessmentView from "./DomainAssessmentView";
import DomainCompletionView from "./DomainCompletionView";
import "./styles.css";

const BackArrow = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path d="M15 6l-6 6 6 6" stroke="#7E7F83" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const VIEW = {
  LIST: "list",
  ASSESSMENT: "assessment",
  COMPLETION: "completion",
};

const YourElementsModal = ({ isOpen, onClose }) => {
  const navigate = useNavigate();
  const [view, setView] = useState(VIEW.LIST);
  const [activeItem, setActiveItem] = useState(null);
  const [animationClass, setAnimationClass] = useState("");

  useEffect(() => {
    if (isOpen) {
      setView(VIEW.LIST);
      setActiveItem(null);
      setAnimationClass("");
    }
  }, [isOpen]);

  const handleSelectItem = (item) => {
    if (!item) return;
    // Completed domains skip the upsell view entirely and jump straight to
    // the periodic-table page filtered to that domain — matches the
    // "See Your Elements" CTA on the completion screen.
    if (item.status === "completed") {
      const target = item.domain_key
        ? `/elements?domain=${encodeURIComponent(item.domain_key)}`
        : "/elements";
      onClose && onClose();
      navigate(target);
      return;
    }
    setActiveItem(item);
    setAnimationClass("ye-view-from-right");
    if (item.status === "next_up") {
      setView(VIEW.ASSESSMENT);
    }
  };

  const handleBack = () => {
    setAnimationClass("ye-view-from-left");
    setView(VIEW.LIST);
    setActiveItem(null);
  };

  const isSubView = view !== VIEW.LIST;

  return (
    <GenericModal
      isOpen={isOpen}
      onClose={onClose}
      heading=""
      primaryLabel=""
      secondaryLabel=""
      maxWidth="560px"
      overlayClassName="ye-overlay"
      containerClassName="ye-container"
    >
      {isSubView && (
        <button
          type="button"
          className="ye-back-button"
          onClick={handleBack}
          aria-label="Back"
        >
          <BackArrow />
        </button>
      )}
      <div className={`ye-stack ${animationClass}`} key={view}>
        {view === VIEW.LIST && (
          <YourElementsList onSelectItem={handleSelectItem} />
        )}
        {view === VIEW.ASSESSMENT && (
          <DomainAssessmentView item={activeItem} />
        )}
        {view === VIEW.COMPLETION && (
          <DomainCompletionView
            item={activeItem}
            onClose={onClose}
          />
        )}
      </div>
    </GenericModal>
  );
};

export default YourElementsModal;
